import { render, staticRenderFns } from "./mrNewsletterSubscription.vue?vue&type=template&id=4e31a621&lang=pug&"
import script from "./mrNewsletterSubscription.vue?vue&type=script&lang=js&"
export * from "./mrNewsletterSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports